module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center-box flex click",
    on: {
      "click": function($event) {
        _vm.$refs.houseQuarterList.popupShow = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.orgName || '全部小区') + "\n            "), _c('div', {
    staticClass: "alifont icon-lujingbeifen"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pd-025 pb-25"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "card pd-25 mt-20 mg"
    }, [_c('div', {
      staticClass: "flex-between flex-center fs-32 pb-15"
    }, [_c('div', [_c('div', {
      staticClass: "color-333 font-bold"
    }, [_vm._v(_vm._s(item.shopName))]), _vm._v(" "), _c('div', {
      staticClass: "color-999 fs-28 mt-5"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), (item.spaceNum != 0) ? _c('div', {
      staticClass: "color-main font-bold"
    }, [_vm._v(_vm._s(item.spaceNum) + "空")]) : _vm._e(), _vm._v(" "), (item.spaceNum == 0) ? _c('div', {
      staticClass: "color-warning font-bold"
    }, [_vm._v("已满")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, _vm._l((item.zoneWayList), function(way, $wayIndex) {
      return _c('div', {
        key: $wayIndex,
        staticClass: "cargo-item",
        class: way.status == 0 ? 'empty' : 'has click'
      }, [_c('div', {
        staticClass: "fs-28 text-center",
        class: way.status == 0 ? 'color-main' : 'color-org'
      }, [_vm._v("货道" + _vm._s(way.wayCode) + "-" + _vm._s(way.status == 0 ? '空' : '已存'))]), _vm._v(" "), (way.status == 1) ? _c('div', {
        staticClass: "cargo-btn",
        on: {
          "click": function($event) {
            return _vm.toDetail(way)
          }
        }
      }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (way.status == 1) ? _c('div', {
        staticClass: "cargo-btn",
        on: {
          "click": function($event) {
            return _vm.clearDetail(way)
          }
        }
      }, [_vm._v("清空")]) : _vm._e()])
    }), 0)])
  }), 0)], 1), _vm._v(" "), _c('houseQuarterList', {
    ref: "houseQuarterList",
    on: {
      "sure": _vm.quarterConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91705c0a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/lockerHouseDetail.vue
// module id = wyAn
// module chunks = 51